import React, { PureComponent } from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import ReactHtmlParser from 'react-html-parser';

import { Icon, Button, Image } from 'semantic-ui-react';
import {
  ReduxFormMaterialTextField,
  ReduxFormHiddenInput,
  ReduxFormSemanticDropdown,
  ReduxFormHiddenRecord,
  ModalTemplate,
  Button as Btn,
  Loading
} from 'components';

import * as attachActions from 'modules/templateAttach';
import { CtExamAttachFile } from 'containers';

import classNames from 'classnames/bind';
import styles from './ExamAttachAdd.css';
const cx = classNames.bind(styles);

class ExamAttachAdd extends PureComponent {
  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const {
      formStore,
      isLoading,
      onToggleModal,
      saveAttach,
      setAttachFile,
      isModal,
      onToggleSelected,
      attachCategory,
      attachExamTypeCheck,
      attachScreenType
    } = this.props;

    let attachExamType = -1;

    if (formStore && formStore.values) {
      if (formStore.values.attachExamType) {
        attachExamType = formStore.values.attachExamType;
      }
    }

    // 부가기능
    const attachFuncList = [
      {
        key: 'PG',
        value: 'PG',
        text: defineMessages(
          formatMessage({
            id: 'ExamAttachFunc_1',
            defaultMessage: 'PG(PC Gather) - PC 정보 수집 기능'
          })
        )
      },
      {
        key: 'LG',
        value: 'LG',
        text: defineMessages(
          formatMessage({
            id: 'ExamAttachFunc_2',
            defaultMessage: 'LG(LeakFile Gather) - PC의 파일 정보 수집 기능'
          })
        )
      },
      {
        key: 'PL',
        value: 'PL',
        text: defineMessages(
          formatMessage({
            id: 'ExamAttachFunc_3',
            defaultMessage: 'PL(PC Lock) - PC 잠금(모의악성) 기능'
          })
        )
      },
      {
        key: 'VS',
        value: 'VS',
        text: defineMessages(
          formatMessage({
            id: 'ExamAttachFunc_4',
            defaultMessage: 'VS(Vaccine Step) - 백신 단계 기능'
          })
        )
      }
    ];

    // 제약사항
    const attachRestrictList = [
      {
        key: 'UAC',
        value: 'UAC',
        text: defineMessages(
          formatMessage({
            id: 'ExamAttachRestrict_1',
            defaultMessage: 'UAC(User Account Control) - Windows 사용자 계정 컨트롤 탐지 가능'
          })
        )
      },
      {
        key: 'SS',
        value: 'SS',
        text: defineMessages(
          formatMessage({
            id: 'ExamAttachRestrict_2',
            defaultMessage: 'SS(Smart Screen) - Windows 스마트 스크린에 탐지 가능'
          })
        )
      },
      {
        key: 'SF',
        value: 'SF',
        text: defineMessages(
          formatMessage({
            id: 'ExamAttachRestrict_3',
            defaultMessage: 'SF(Spam Filter) - 메일 스팸 필터에 탐지 가능'
          })
        )
      },
      {
        key: 'VD',
        value: 'VD',
        text: defineMessages(
          formatMessage({
            id: 'ExamAttachRestrict_4',
            defaultMessage: 'VD(Vaccine Detect) - 백신 탐지 가능함(V3, 알약···)'
          })
        )
      },
      {
        key: 'LC',
        value: 'LC',
        text: defineMessages(
          formatMessage({
            id: 'ExamAttachRestrict_5',
            defaultMessage: 'LC(Link Click) - 문서 안에 링크를 클릭해야 감염 처리'
          })
        )
      },
      {
        key: 'UC',
        value: 'UC',
        text: defineMessages(
          formatMessage({
            id: 'ExamAttachRestrict_6',
            defaultMessage: 'UC(User Control) - 사용자의 동의가 필요함'
          })
        )
      },
      {
        key: 'DW',
        value: 'DW',
        text: defineMessages(
          formatMessage({
            id: 'ExamAttachRestrict_7',
            defaultMessage: 'DW(Download Warning) - 메일에서 파일 다운로드시 경고 발생'
          })
        )
      }
    ];

    return (
      <div>
        {isModal === 'examAttachAdd' && (
          <ModalTemplate
            closeOnEscape={false}
            closeOnDimmerClick={false}
            closeOnDocumentClick={false}
            onToggleModal={onToggleModal}
            className={cx('modal-template-edit', 'modal-admin', 'common-content')}
            closeIcon={
              <Icon
                name="close"
                link
                onClick={() => {
                  onToggleModal('');
                }}
              />
            }
            visible
            scrolling
            header={
              <div className={cx('modal-custom-header')}>
                <div className={cx('modal-template-title')}>
                  {defineMessages(formatMessage({ id: 'AdminMenu_10', defaultMessage: '첨부파일 등록' }))}
                </div>
              </div>
            }
            buttons={
              <div className={cx('inline-block', 'bt-area-right')}>
                <Btn
                  buttonColor="#bbbbbb"
                  loading={isLoading}
                  disabled={isLoading}
                  onClick={() => {
                    onToggleModal('');
                  }}>
                  {defineMessages(formatMessage({ id: 'ExamTemplateEditModal_4', defaultMessage: '취소' }))}
                </Btn>
                <Btn
                  className={cx('brand-button')}
                  buttonColor="#ffffff"
                  loading={isLoading}
                  disabled={isLoading}
                  onClick={saveAttach}>
                  {defineMessages(formatMessage({ id: 'ExamTemplateEditModal_5', defaultMessage: '저장' }))}
                </Btn>
              </div>
            }>
            <div className={cx('template-edit-box', 'attach-add-wrap')}>
              <Loading active={isLoading} size="small" content={'Loading...'} />
              <div>
                {/* 첨부파일 제목 */}
                <div className={cx('template-edit-section')}>
                  <div className={cx('input-title')}>
                    {defineMessages(formatMessage({ id: 'AdminMenu_8', defaultMessage: '첨부파일' }))}
                  </div>
                  <span className={cx('materialTextField-title')}>
                    {defineMessages(formatMessage({ id: 'ExamAttachAdd_1', defaultMessage: '제목' }))}
                  </span>
                  <ReduxFormMaterialTextField
                    required
                    fullWidth
                    className={cx('input-gap', 'input-area')}
                    name="attachSubject"
                    checkType={101}
                    validate={['required', 'templateName']}
                  />
                </div>
                {/* 첨부파일 훈련 유형 */}
                <div className={cx('template-edit-section')}>
                  <div className={cx('input-button')}>
                    <span className={cx('materialTextField-title')}>
                      {defineMessages(formatMessage({ id: 'ExamAttachAdd_8', defaultMessage: '첨부파일 훈련 유형' }))}
                    </span>
                    <div className={cx('input-button-comm', 'input-button-exam')}>
                      <div className={cx('button-exam', 'input-button-attach')}>
                        <Button
                          className={cx('input-button-exam-in')}
                          onClick={() => onToggleSelected({ attachExamType: 1 })}
                          active={attachExamTypeCheck === 1}>
                          <div>
                            <i className={cx('input-button-check')} />
                            <Image src="/img/template/setting/exam_warning.png" />
                            <div className={cx('exam-title')}>
                              {defineMessages(
                                formatMessage({ id: 'ExamTemplateEdit_72', defaultMessage: '경고 안내' })
                              )}
                            </div>
                            <div className={cx('exam-subtitle')}>
                              {defineMessages(
                                formatMessage({ id: 'ExamTemplateEdit_73', defaultMessage: '훈련임을 안내' })
                              )}
                            </div>
                            <span className={cx('exam-content', 'exam-content-exc')}>
                              {ReactHtmlParser(
                                defineMessages(
                                  formatMessage({
                                    id: 'ExamTemplateEdit_74',
                                    defaultMessage:
                                      'PC 잠금 화면이 실행되어 대상자에게 경고 문구를 안내해주는 훈련입니다.'
                                  })
                                )
                              )}
                            </span>
                          </div>
                        </Button>
                      </div>
                      <div className={cx('button-exam', 'input-button-attach')}>
                        <Button
                          className={cx('input-button-exam-in')}
                          onClick={() => onToggleSelected({ attachExamType: 2 })}
                          active={attachExamTypeCheck === 2}>
                          <div>
                            <i className={cx('input-button-check')} />
                            <Image src="/img/template/setting/exam_file.png" />
                            <div className={cx('exam-title')}>
                              {defineMessages(
                                formatMessage({ id: 'ExamTemplateEdit_75', defaultMessage: '모의 악성파일' })
                              )}
                            </div>
                            <div className={cx('exam-subtitle')}>
                              {defineMessages(formatMessage({ id: 'ExamTemplateEdit_76', defaultMessage: 'PC 잠금' }))}
                            </div>
                            <span className={cx('exam-content', 'exam-content-exc')}>
                              {ReactHtmlParser(
                                defineMessages(
                                  formatMessage({
                                    id: 'ExamTemplateEdit_77',
                                    defaultMessage:
                                      'PC 잠금 화면이 실행되어 대상자가 PC를 사용할 수 없게 되는 훈련입니다.'
                                  })
                                )
                              )}
                            </span>
                          </div>
                        </Button>
                      </div>
                      <div className={cx('button-exam', 'input-button-attach')}>
                        <Button
                          className={cx('input-button-exam-in')}
                          onClick={() => onToggleSelected({ attachExamType: 3 })}
                          active={attachExamTypeCheck === 3}>
                          <div>
                            <i className={cx('input-button-check')} />
                            <Image src="/img/template/setting/exam_cheat.png" />
                            <div className={cx('exam-title')}>
                              {defineMessages(
                                formatMessage({ id: 'ExamTemplateEdit_78', defaultMessage: '실태 조사' })
                              )}
                            </div>
                            <div className={cx('exam-subtitle')}>
                              {defineMessages(
                                formatMessage({ id: 'ExamTemplateEdit_79', defaultMessage: '훈련임을 숨김' })
                              )}
                            </div>
                            <span className={cx('exam-content')}>
                              {defineMessages(
                                formatMessage({
                                  id: 'ExamTemplateEdit_80',
                                  defaultMessage: '첨부파일의 형태로 실행되어 대상자가 훈련임을 알 수 없는 훈련입니다.'
                                })
                              )}
                              <br />
                              {defineMessages(
                                formatMessage({ id: 'ExamTemplateEdit_81', defaultMessage: 'ex) excel이 실행됨' })
                              )}
                            </span>
                          </div>
                        </Button>
                      </div>
                      <ReduxFormHiddenRecord
                        name="attachExamType"
                        validate={['required']}
                        valuePass={attachExamTypeCheck}
                      />
                    </div>
                  </div>
                </div>
                {/* 구분 */}
                <div className={cx('template-edit-section')}>
                  <div className={cx('input-button')}>
                    <span className={cx('materialTextField-title')}>
                      {defineMessages(formatMessage({ id: 'ExamAttachAdd_18', defaultMessage: '구분' }))}
                    </span>
                    <div className={cx('input-button-comm')}>
                      <div className={cx('button-exam')}>
                        <Button onClick={() => onToggleSelected({ attachCategory: 1 })} active={attachCategory === 1}>
                          <span>
                            {defineMessages(formatMessage({ id: 'ExamAttachCategory_1', defaultMessage: '실행파일' }))}
                            <i className={cx('input-button-check')} />
                          </span>
                        </Button>
                      </div>
                      <div className={cx('button-exam')}>
                        <Button onClick={() => onToggleSelected({ attachCategory: 2 })} active={attachCategory === 2}>
                          <span>
                            {defineMessages(formatMessage({ id: 'ExamAttachCategory_2', defaultMessage: '바로가기' }))}
                            <i className={cx('input-button-check')} />
                          </span>
                        </Button>
                      </div>
                      <div className={cx('button-exam')}>
                        <Button onClick={() => onToggleSelected({ attachCategory: 3 })} active={attachCategory === 3}>
                          <span>
                            {defineMessages(formatMessage({ id: 'ExamAttachCategory_3', defaultMessage: '문서파일' }))}
                            <i className={cx('input-button-check')} />
                          </span>
                        </Button>
                      </div>
                      <div className={cx('button-exam')}>
                        <Button onClick={() => onToggleSelected({ attachCategory: 4 })} active={attachCategory === 4}>
                          <span>
                            {defineMessages(formatMessage({ id: 'ExamAttachCategory_4', defaultMessage: '웹 문서' }))}
                            <i className={cx('input-button-check')} />
                          </span>
                        </Button>
                      </div>
                      <ReduxFormHiddenRecord name="attachCategory" validate={['required']} valuePass={attachCategory} />
                    </div>
                  </div>
                </div>
                {/* 부가기능 */}
                <div className={cx('template-edit-section')}>
                  <div className={cx('select-target-area')}>
                    <span className={cx('materialTextField-title')}>
                      {defineMessages(formatMessage({ id: 'ExamAttachAdd_19', defaultMessage: '부가 기능' }))}
                    </span>
                    <div className={cx('list-list')}>
                      <div className={cx('list-dropdown', 'drop-area')}>
                        <ReduxFormSemanticDropdown
                          placeholder={defineMessages(
                            formatMessage({ id: 'ExamAttachAdd_21', defaultMessage: '부가기능을 선택하세요' })
                          )}
                          name="attachFunction"
                          className={cx('list-target')}
                          fluid
                          multiple
                          search
                          selection
                          selectOnBlur={false}
                          options={attachFuncList}
                          checkType={100}
                          label="d"
                        />
                      </div>
                    </div>
                  </div>
                  <ReduxFormHiddenInput name="attachFunction" />
                </div>
                {/* 제약사항 */}
                <div className={cx('template-edit-section')}>
                  <div className={cx('select-target-area')}>
                    <span className={cx('materialTextField-title')}>
                      {defineMessages(formatMessage({ id: 'ExamAttachAdd_20', defaultMessage: '제약 사항' }))}
                    </span>
                    <div className={cx('list-list')}>
                      <div className={cx('list-dropdown', 'drop-area')}>
                        <ReduxFormSemanticDropdown
                          placeholder={defineMessages(
                            formatMessage({ id: 'ExamAttachAdd_22', defaultMessage: '제약 사항을 선택하세요' })
                          )}
                          name="attachRestrict"
                          className={cx('list-target')}
                          fluid
                          multiple
                          search
                          selection
                          selectOnBlur={false}
                          options={attachRestrictList}
                          checkType={100}
                        />
                      </div>
                    </div>
                  </div>
                  <ReduxFormHiddenInput name="attachRestrict" />
                </div>
                <div className={cx('template-edit-section', 'attach-file-upload')}>
                  {/* 실행 파일 */}
                  <div className={cx('dropzone-wrap')}>
                    <span className={cx('materialTextField-title')}>
                      {defineMessages(formatMessage({ id: 'ExamAttachAdd_23', defaultMessage: '실행파일' }))}
                    </span>
                    <CtExamAttachFile type="attachFile" setAttachFile={setAttachFile} />
                  </div>
                  {/* 아이콘 */}
                  <div className={cx('dropzone-wrap')}>
                    <span className={cx('materialTextField-title')}>
                      {defineMessages(formatMessage({ id: 'ExamAttachAdd_24', defaultMessage: '아이콘' }))}
                    </span>
                    <CtExamAttachFile type="fileIcon" setAttachFile={setAttachFile} />
                  </div>
                  {/* 실행결과 이미지 */}
                  <div className={cx('dropzone-wrap')}>
                    <span className={cx('materialTextField-title')}>
                      {defineMessages(formatMessage({ id: 'ExamAttachAdd_25', defaultMessage: '실행결과' }))}
                    </span>
                    <CtExamAttachFile type="actionImage" setAttachFile={setAttachFile} />
                  </div>
                </div>
                {/* 모의 악성코드 화면 설정 */}
                {/* {(attachExamType === 1 || attachExamType === 2) && (
                  <div className={cx('template-edit-section', 'attach-screen-wrap')}>
                    <div className={cx('input-title')}>
                      {defineMessages(
                        formatMessage({ id: 'ExamTemplateEdit_49', defaultMessage: 'PC 잠금 화면 설정' })
                      )}
                    </div>
                    {attachExamType === 2 && (
                      // <div className={cx('flex-row-flex-start')}>
                      //   <ReduxFormMaterialSelect
                      //     required
                      //     label={defineMessages(
                      //       formatMessage({ id: 'ExamTemplateEdit_50', defaultMessage: 'PC 잠금 해제 방법' })
                      //     )}
                      //     name="attachScreenType"
                      //     className={cx('input-gap')}
                      //     fullWidth
                      //     menuList={[
                      //       {
                      //         key: 1,
                      //         value: 1,
                      //         text: defineMessages(
                      //           formatMessage({ id: 'ExamTemplateEdit_53', defaultMessage: '닫기 버튼 클릭' })
                      //         )
                      //       },
                      //       {
                      //         key: 2,
                      //         value: 2,
                      //         text: defineMessages(
                      //           formatMessage({ id: 'ExamTemplateEdit_52', defaultMessage: '비밀번호 입력' })
                      //         )
                      //       }
                      //     ]}
                      //     checkType={101}
                      //   />
                      // </div>
                      <div className={cx('input-button')}>
                        <span className={cx('materialTextField-title')}>
                          {defineMessages(
                            formatMessage({ id: 'ExamTemplateEdit_49', defaultMessage: 'PC 잠금 화면 설정' })
                          )}
                        </span>
                        <div className={cx('input-button-comm', 'input-button-eqline')}>
                          <div className={cx('button-exam')}>
                            <Button
                              onClick={() => onToggleSelected({ attachScreenType: 1 })}
                              active={attachScreenType === 1}>
                              <span>
                                {defineMessages(
                                  formatMessage({ id: 'ExamTemplateEdit_53', defaultMessage: '닫기 버튼 클릭' })
                                )}
                                <i className={cx('input-button-check')} />
                              </span>
                            </Button>
                          </div>
                          <div className={cx('button-exam')}>
                            <Button
                              onClick={() => onToggleSelected({ attachScreenType: 2 })}
                              active={attachScreenType === 2}>
                              <span>
                                {defineMessages(
                                  formatMessage({ id: 'ExamTemplateEdit_52', defaultMessage: '비밀번호 입력' })
                                )}
                                <i className={cx('input-button-check')} />
                              </span>
                            </Button>
                          </div>
                          <ReduxFormHiddenRecord
                            name="attachScreenType"
                            validate={['required']}
                            valuePass={attachScreenType}
                          />
                        </div>
                      </div>
                    )}
                    <span className={cx('materialTextField-title', 'input-gap-top')}>
                      {defineMessages(
                        formatMessage({ id: 'ExamTemplateEdit_57', defaultMessage: 'PC 잠금 화면 내용' })
                      )}
                    </span>
                    <div className={cx('detail-reduxTextField', 'detail-attach-add')}>
                      <ReduxFormMaterialTextField
                        name="attachScreenContent"
                        multiline
                        rows="20"
                        checkType={101}
                        validate={['range5000']}
                      />
                    </div>
                  </div>
                )} */}
              </div>
            </div>
          </ModalTemplate>
        )}
      </div>
    );
  }
}

ExamAttachAdd.propTypes = {};
ExamAttachAdd.defaultProps = {};

export default injectIntl(ExamAttachAdd);



// WEBPACK FOOTER //
// ./src/script/components/examAttach/ExamAttachAdd.js